import { OEQ_RESPONSE_CHANGE } from "../Redux.constants";

export const responseOEQChange = (response) => ({
  type: OEQ_RESPONSE_CHANGE,
  payload: response,
});
